<div class="dashboard-container">
  
  <!-- dashboard -->
  <div *ngIf="!systemService.inGameMode$.value">
    <div fxLayout="row" fxLayoutAlign="center baseline">
      <h3>1.</h3>&nbsp;
      <h1>{{ 'DASHBOARD.STEP.1' | translate }}</h1>
    </div>

    <!-- keyboard -->
    <div class="keyboard-carousel" fxLayout="row" fxLayoutAlign="center center">

      <i class="ri-arrow-left-s-line" (click)="keyboardChanged$.next('left')"></i>

      <img src="{{ 'assets/images/keyboards/kb' + user.keyboard_in_use + '.png' }}" />

      <i class="ri-arrow-right-s-line" (click)="keyboardChanged$.next('right')"></i>

    </div>

    <!--  launch now -->
    <div class="launch-header" fxLayout="row" fxLayoutAlign="center baseline">
      <h3>2.</h3>&nbsp;
      <h1>{{ 'DASHBOARD.STEP.2' | translate }}</h1>
    </div>

    <div class="launch-container" fxLayout="row" fxLayoutAlign="center center">
      <img src="assets/images/keyboards/kbp_image.png"/>
      <div class="primary-button" (click)="launch()">{{ 'DASHBOARD.START.BTN' | translate }}</div>
    </div>

  </div>

  <!-- Course running -->
  <div *ngIf="systemService.inGameMode$.value"></div>

</div>